import type { CurrencyState } from './slice/currencySlice';

export function selectCurrencySettled(state: CurrencyState) {
  return state.currencyStatus === 'ready';
}
